<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
<!--                        {{ $t('message.edit') }} {{ $tc('message.obstetricParameters', 1) }}-->
                        {{ $t('message.edit') }}  {{$t('message.parameter') }}

                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="p-1em">
                    <h3 class="card-title text-center mb-0">
                        {{prenatalConsultationInformation}}
                    </h3>
                </div>
                <b-form  @reset="onReset" v-if="show">
                    <b-container>
                        <b-row>
                            <b-col sm="4">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="weight-group"
                                        :label="$t('message.weight')"
                                        label-for="weight"
                                        description=""
                                >
                                    <b-form-input
                                            id="weight"
                                            v-model="$v.form.poids.$model"
                                            :state="$v.form.poids.$dirty ? !$v.form.poids.$error : null"
                                            type="number"
                                            required
                                            placeholder=""
                                            @keydown="clearErrorField('poids')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback  v-if="$v.form.weight.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <span v-if="errorshasField('poids')" style="color:red">
                                    {{getErrorsField('poids')}}
                                    </span>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group
                                        id="taSystolique-group"
                                        :label="$t('message.taSystolique')"
                                        label-for="taSystolique">
                                    <b-form-input
                                            id="taSystolique"
                                            v-model="$v.form.ta_systolique.$model"
                                            :state="$v.form.ta_systolique.$dirty ? !$v.form.ta_systolique.$error : null"
                                            type="number"
                                            @keydown="clearErrorField('ta_systolique')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback>
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <span v-if="errorshasField('ta_systolique')" style="color:red">
                                    {{getErrorsField('ta_systolique')}}
                                    </span>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group
                                        id="taDiastolique-group"
                                        :label="$t('message.taDiastolique')"
                                        label-for="taDiastolique">
                                    <b-form-input
                                            id="taDiastolique"
                                            v-model="$v.form.ta_diastolique.$model"
                                            :state="$v.form.ta_diastolique.$dirty ? !$v.form.ta_diastolique.$error : null"
                                            type="number"
                                            @keydown="clearErrorField('ta_diastolique')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback>
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <span v-if="errorshasField('ta_diastolique')" style="color:red">
                                    {{getErrorsField('ta_diastolique')}}
                                    </span>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="4">
                                <b-form-group
                                        id="urineHeight-group"
                                        :label="$t('message.urineHeight')"
                                        label-for="urineHeight"
                                        description=""
                                >
                                    <b-form-input
                                            id="urineHeight"
                                            v-model="$v.form.hauteur_urine.$model"
                                            :state="$v.form.hauteur_urine.$dirty ? !$v.form.hauteur_urine.$error : null"
                                            type="number"
                                            @keydown="clearErrorField('hauteur_urine')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback>
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <span v-if="errorshasField('hauteur_urine')" style="color:red">
                                    {{getErrorsField('hauteur_urine')}}
                                    </span>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group
                                        id="touchVaginal-group"
                                        :label="$t('message.touchVaginal')"
                                        label-for="touchVaginal"
                                        description=""
                                >
                                    <b-form-input
                                            id="touchVaginal"
                                            v-model="$v.form.toucher_vaginal.$model"
                                            :state="$v.form.toucher_vaginal.$dirty ? !$v.form.toucher_vaginal.$error : null"
                                            type="number"
                                            @keydown="clearErrorField('toucher_vaginal')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback>
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <span v-if="errorshasField('toucher_vaginal')" style="color:red">
                                    {{getErrorsField('toucher_vaginal')}}
                                    </span>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group
                                        id="heartNoise-group"
                                        :label="$t('message.heartNoise')"
                                        label-for="heartNoise"
                                        description=""
                                >
                                    <b-form-input
                                            id="heartNoise"
                                            v-model="$v.form.bruit_du_coeur.$model"
                                            :state="$v.form.bruit_du_coeur.$dirty ? !$v.form.bruit_du_coeur.$error : null"
                                            type="number"
                                            @keydown="clearErrorField('bruit_du_coeur')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback>
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <span v-if="errorshasField('bruit_du_coeur')" style="color:red">
                                    {{getErrorsField('bruit_du_coeur')}}
                                    </span>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-container>
                    <b-container>
                        <b-row class="justify-content-sm-center" v-if="form.isAuthor || hasAdminRole">
                            <b-button @click="onSubmit" variant="primary">
                                {{ $t('message.edit') }}
                            </b-button>

<!--                            <b-button type="reset" variant="danger">-->
<!--                                {{ $t('message.reset') }}-->
<!--                            </b-button>-->
                        </b-row>
                    </b-container>
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import { required } from 'vuelidate/lib/validators';
    import { mapGetters } from 'vuex';

    export default {
        name: "EditObstetric",
        computed: {
            ...mapGetters(["obstetricParameter",'errors', "hasAdminRole", "hasMedecinControleRole", "hasPraticienRole","hasAssistante"]),

            can: function (){
                if (this.hasAdminRole){
                    return true;
                }else{
                    return this.hasMedecinControleRole || this.hasPraticienRole || this.hasAssistante;
                }
            },

            prenatalConsultationInformation:function(){
                if (typeof this.obstetricParameter.consultation_prenatale == 'object'){
                    return this.obstetricParameter.consultation_prenatale.type_de_consultation;
                }
                return  "";
            },

            form: function() {
                return this.obstetricParameter;
            },
        },
        data() {
            return {
                consultation_id: this.$route.params.parametreObstetrique,
                show: true,
            }
        },
        methods: {
            getObstetricParameter: function() {
                let args = {
                    parametreObstetrique: this.consultation_id
                };
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getObstetricParameter', { args, errorMessages });
            },

            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();

                if(!this.$v.$invalid) {
                    let args = {
                        consultation_prenatale_id:this.obstetricParameter.consultation_prenatale.id,
                        parametreObstetrique:this.obstetricParameter.slug,
                        poids:this.form.poids,
                        ta_systolique:this.form.ta_systolique,
                        ta_diastolique:this.form.ta_diastolique,
                        hauteur_urine:this.form.hauteur_urine,
                        toucher_vaginal:this.form.toucher_vaginal,
                        bruit_du_coeur:this.form.bruit_du_coeur,
                    };

                    let successMessage = this.$i18n.t('message.obstetricParameterUpdated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('updateObstetricParameter', { args, errorMessages, successMessage });
                }
            },

            onReset: function(evt) {
                // evt.preventDefault();
                //
                // // Reset our form values
                // // this.form.numero_grossesse = '';
                // this.consultation_obstetrique_id='';
                // this.typeOfConsultation= '';
                // this.complaints= '';
                // this.antecedentSpouse= '';
                // this.recommendations= '';
                //
                // // Trick to reset/clear native browser form validation state
                // this.show = false;
                //
                // this.$nextTick(() => {
                //     this.show = true;
                // });
            },
            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },
            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },
            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });
                this.getErrorsField(field);
            }
        },

        validations: {
            form: {
                poids: {
                    required
                },
                ta_diastolique: {
                    //
                },
                ta_systolique: {
                    //
                },
                hauteur_urine: {
                    //
                },
                toucher_vaginal: {
                    //
                },
                bruit_du_coeur: {
                    //
                }
            }
        },

        mounted() {
            // Fetch ultrasound list
            this.getObstetricParameter();
        }
    }
</script>

<style scoped>

</style>